//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useContext, useEffect } from "react";

// custom pages
import { styles } from "./styles";
import WelcomeEmailReport from "./WelcomeEmailReport";
import BenefitCodeWeeklyReport from "./BenefitCodeWeeklyReport";
import PointExpirationMonthly from "./PointsExpirationMontlhly";
import FiscalMonthReport from "./FiscalMonthReport";
import FSCSummaryReport from "./FSCSummaryReport";
import ConsentedAndNonConsentedWeeklyReport from "./ConsentedAndNonConsentedWeeklyReport";
import ConsentedAndNonConsentedMonthlyReport from "./ConsentedAndNonConsentedMonthlyReport";
import FSCConsentWeeklyReport from "./FSCConsentWeeklyReport";
import MarketoMailchimpReport from "./MarketoMailchimpReport";
import Context from "context/context";

// material-ui
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import CreateOnewebAllowedUser from "./CreateOnewebAllowedUser";
import OnewebRestrictedShipto from "./OnewebRestrictedAccounts";
import SignatureStatement from "./SignatureStatement";
import RollForwardFunc from "./RollForward"





const GlobalCss = withStyles({
  "@global": {
    ".MuiFormLabel-root": {
      color: "black",
    },
  },
})(() => null);

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
  },
  palette: {
    primary: {
      main: "#000000",
    },
  },
});

export default function KPIReprts(props) {
  const { state, dispatch } = useContext(Context);
  const classes = styles();

  const [disableDropdown, setDisableDropdown] = useState(false);
  const [states, setstates] = useState({
    currentReport: "",
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);
  const reports = [
    {
      reportName: "Welcome Email Report",
      id: 0,
    },
    {
      reportName: "Benefit Code Weekly Report",
      id: 1,
    },
    {
      reportName: "Fiscal Month Report",
      id: 2,
    },
    {
      reportName: "FSC Summary Report",
      id: 3,
    },
    {
      reportName: "Consented and Non Consented Weekly Report",
      id: 4,
    },
    {
      reportName: "Consented and Non Consented Monthly Report",
      id: 5,
    },
    {
      reportName: "FSC Consent Weekly Report",
      id: 6,
    },
    {
      reportName: (state?.userInfo?.loyalty_organization_name === "Henry Schein Dental") ? "Marketo Report" : "MailChimp Report",
      id: 7
    },
    {
      reportName: "Oneweb Allowed Users",
      id: 8
    },
    state?.userInfo?.loyalty_organization_name === "Henry Schein Canada" ? {
      reportName: "Oneweb Restricted Shipto",
      id: 9
    }:'', state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ?
    {
      reportName: "Signature Statement",
      id: 10
    }:'',
    {
      reportName: "Roll Forward",
      id: 11
    },

    state?.userInfo?.loyalty_organization_name === "Henry Schein Canada" ? {
      reportName: "Point Expiration Monthly",
      id: 12
    }:""

  ];

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "KPI Reports"],
    });
  }, []);

  // report tab switch case
  function setReport(tab) {
    switch (tab) {
      case 0:
        return (
          <WelcomeEmailReport
            page={"Welcome Email"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 1:
        return (
          <BenefitCodeWeeklyReport
            page={"Benefit Code Weekly Report"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 2:
        return (
          <FiscalMonthReport
            page={"Fiscal Month Report"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 3:
        return (
          <FSCSummaryReport
            page={"FSC Summary Report"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 4:
        return (
          <ConsentedAndNonConsentedWeeklyReport
            page={"Consented And NonConsented Weekly Report"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 5:
        return (
          <ConsentedAndNonConsentedMonthlyReport
            page={"Consented And Non Consented Monthly Report"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 6:
        return (
          <FSCConsentWeeklyReport
            page={"FSC Consent Weekly Report"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 7:
        return (
          <MarketoMailchimpReport
            page={(state?.userInfo?.loyalty_organization_name === "Henry Schein Dental") ? "Marketo Report" : "MailChimp Report"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 8:
        return (
          <CreateOnewebAllowedUser
            page={"Oneweb Allowed Users"}
            setDisableDropdown={setDisableDropdown}
          />
        );
      case 9:
        return (
          <OnewebRestrictedShipto
            page={"Oneweb Restricted Shipto"}
            setDisableDropdown={setDisableDropdown}
          />
        );
        case 10:
          return (
            <SignatureStatement
              page={"Signature Statement"}
              setDisableDropdown={setDisableDropdown}
            />
          );
          case 11:
            return (
              <RollForwardFunc
                page={"Roll Forward"}
                setDisableDropdown={setDisableDropdown}
              />
            );

            case 12:
            return (
              <PointExpirationMonthly
                page={"Point Expiration Monthly"}
                setDisableDropdown={setDisableDropdown}
              />
            );
    }
  }

  return (
    <React.Fragment>
      <GlobalCss />
      <Grid container className={classes.root}>
        <Grid xs={12} sm={12} lg={12} className={classes.topGrid}>
          <ThemeProvider theme={formLabelsTheme}>
            <TextField
              id={"report"}
              label={"Select Report Type"}
              select
              required
              type={"text"}
              className={classes.input}
              value={states.currentReport}
              onChange={(e) => {
                setStates({
                  currentReport: e.target.value,
                });
              }}
              disabled={disableDropdown}
            >
              {reports.map((r, i) => (
                <MenuItem value={r.id} key={r.reportName}>
                  {r.reportName}
                </MenuItem>
              ))}
            </TextField>
          </ThemeProvider>
        </Grid>
      </Grid>
      <div>{setReport(states.currentReport)}</div>
    </React.Fragment>
  );
}
